import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="bg-panel tech-grid-light py-16 sm:py-20" aria-labelledby="system-title" data-id="element-232" data-mp="3bhljv43cc8l2">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-233" data-mp="36j0iv2g9lkvk">
        <span className="inline-flex items-center gap-2 rounded-md bg-forest px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-sageGlow" data-id="element-234" data-mp="31kgy35deqf4s">
          <AwardIcon className="h-4 w-4" aria-hidden="true" data-id="element-235" data-mp="2wsfltjg8ooer" /> The most comprehensive wine studies teaching system in
          the world
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-236" data-mp="2ntuaa896q9nh">
          Wine Studies &amp; Oenology Teacher Ready
        </h2>
        <p className="mt-3 font-semibold text-muted" data-id="element-237" data-mp="2dveh7zqlkqbc">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses · Everything you need to teach wine with confidence.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-238" data-mp="18py3anst8rl5">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-line bg-cream p-4 text-sm font-semibold text-muted" data-id="element-239" data-mp="u1ti9d6ac3z7">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" aria-hidden="true" data-id="element-240" data-mp="1crs02kzvxbg1" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl border border-sage/40 bg-sageSoft p-6 text-left text-lg font-bold leading-relaxed text-ink" data-id="element-241" data-mp="1horx66erb3v0">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-sage" aria-hidden="true" data-id="element-242" data-mp="6cissrudxw0d" />
          It&apos;s a complete system so you can enter the classroom with confidence and deliver lessons that truly teach
          how grapes become wine and wine becomes an experience.
        </p>
      </div>
    </section>;
}